import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {MedicalReportModel} from './medicalReport.model';
import {Injectable} from '@angular/core';
import {ExamFormSummaryConverter} from '../../../../exam-form/api/converter/examFormSummary.converter';
import {ReportConverter} from '../../../../reporting/report/api/entity/converter/report.converter';
import {
    ConsultationSummaryConverter
} from '../../../consultation/consultation/api/model/converter/consultationSummary.converter';
import {TreatmentSummaryConverter} from '../../../treatment/common/api/converter/treatmentSummary.converter';

@Injectable()
export class MedicalReportConverter extends HttpModelConverter<MedicalReportModel>{

    constructor(private examConverter: ExamFormSummaryConverter,
                private reportConverter: ReportConverter,
                private consultationSummaryConverter: ConsultationSummaryConverter,
                private treatmentSummaryConverter: TreatmentSummaryConverter) {
        super();
    }

    protected createInstance(): MedicalReportModel {
        return new MedicalReportModel();
    }

    protected enrichObject(result: MedicalReportModel, src: MedicalReportModel) {
        result.examForms = this.examConverter.convertFromArray(src.examForms);
        result.report = this.reportConverter.convert(src.report);
        result.consultation = this.consultationSummaryConverter.convert(src.consultation);
        result.treatments = this.treatmentSummaryConverter.convertFromArray(src.treatments);
    }
}
